import React from 'react';
import { BannerProps, money, sumRows } from './BannerProps';

const paper: React.CSSProperties = {
  background: '#fff',
  color: '#111',
  fontFamily: 'Helvetica, Arial, sans-serif',
  borderRadius: 6,
  padding: '12px 14px',
  maxWidth: '100%',
  boxSizing: 'border-box',
};

/**
 * Design 7: bundle. A package priced under the sum of its parts — the
 * saving does the arguing. Owner-approved mockup #07. The saving is
 * shown only at the bundle total, not repeated on every line.
 */
const BundleBanner: React.FC<BannerProps> = ({ promotion, brandColor = '#1e5aa8' }) => {
  const was = sumRows(promotion.rows);
  const now = promotion.totalCents ?? 0;
  const saving = Math.max(0, was - now);

  return (
    <div style={paper}>
      <p style={{ fontSize: 11, letterSpacing: '0.12em', color: brandColor, fontWeight: 700, margin: '0 0 8px', textTransform: 'uppercase' }}>
        {promotion.headline ?? promotion.name}
      </p>
      {promotion.rows.map((row, i) => (
        <div
          key={`${row.label}-${i}`}
          style={{ display: 'flex', justifyContent: 'space-between', gap: 10, fontSize: 13, padding: '5px 0' }}
        >
          <span style={{ minWidth: 0, overflowWrap: 'break-word' }}>{row.label}</span>
          <span>{money(row.priceCents)}</span>
        </div>
      ))}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 10,
          flexWrap: 'wrap',
          borderTop: '1px solid #cfd6de',
          marginTop: 4,
          paddingTop: 8,
        }}
      >
        <span style={{ fontWeight: 700 }}>Bundle price</span>
        <span style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'baseline', justifyContent: 'flex-end' }}>
          <span style={{ textDecoration: 'line-through', color: '#9aa2ac' }}>{money(was)}</span>
          <span style={{ fontWeight: 700, fontSize: 14 }}>{money(now)}</span>
          <span style={{ color: '#15803d', fontWeight: 700 }}>save {money(saving)}</span>
        </span>
      </div>
    </div>
  );
};

export default BundleBanner;
